<template>
  <div
    class="goals-option-v5"
    :class="optionClass"
  >
    <div class="goals-option-v5__name">
      <slot name="name" />
    </div>
    <slot
      v-if="$slots.description"
      name="descriptionWrapper"
    >
      <div class="goals-option-v5__description">
        <slot name="description" />
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    optionClass () {
      return {
        'goals-option-v5--active': this.isActive,
      }
    },
  },
}
</script>

<style lang="scss">
.goals-option-v5 {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid map-get($colors, 'grey_8');
  padding: .12rem 0;
  border-radius: .16rem;
  font-size: .16rem;
  transition: border-color .3s;
  &__description {
    position: absolute;
    top: -.06rem;
    right: -.06rem;
    padding: .04rem .06rem;
    background: map-get($colors, 'red');
    border-radius: .08rem;
    color: map-get($colors, 'white');
    font-weight: 500;
    font-size: .08rem;
    line-height: .08rem;
    @include typography('c4', 'medium');
    text-align: right;
    letter-spacing: 0.006rem;
    text-transform: uppercase;
  }
  &__name{
    text-align: center;
    @include typography('h4', 'bold');
    letter-spacing: 0.004rem;
    color: map-get($colors, 'grey_60');
    transition: color .3s;
  }
  &--active {
    border-width: 0.02rem;
    margin: -0.01rem;
    border-color: map-get($colors, 'default');
    .goals-option-v5 {
      &__name {
        color: map-get($colors, 'black');
      }
    }
  }
}
</style>
